import http from "../axios/http-common";

class InterfaceSkDiagnosa {
  getSkDiagnosa(reg) {
    return http.getData(`/register/${reg}/suket-diagnosa`);
  }

  getSkDiagnosaByID(id) {
    return http.getData(`/suket-diagnosa/${id}`);
  }

  deleteSkDiagnosaByID(id) {
    return http.deleteData(`/suket-diagnosa/${id}`);
  }

  saveTtdSkDiagnosa(id, user_id, password) {
    // return http.postData(`/skdp/${id}/signature`, {
    return http.postData(`/suket-diagnosa/${id}/signature`, {
      user_id: user_id,
      password: password
    });
  }

  saveSkDiagnosa(
    reg,
    rm,
    dpjp_id,
    unit_id,
    diagnosis,
    tindak_lanjut_id,
    klinik_tujuan_id
  ) {
    return http.postData(`/suket-diagnosa`, {
      register_id: reg,
      pasien_rm: rm,
      dokter_id: dpjp_id,
      unit_id: unit_id,
      diagnosis: diagnosis,
      tindak_lanjut_id: tindak_lanjut_id,
      klinik_tujuan_id: klinik_tujuan_id
    });
  }

  changeSkDiagnosa(
    id,
    reg,
    rm,
    dpjp_id,
    unit_id,
    diagnosis,
    tindak_lanjut_id,
    klinik_tujuan_id
  ) {
    return http.putData(`/suket-diagnosa/${id}`, {
      register_id: reg,
      pasien_rm: rm,
      dokter_id: dpjp_id,
      unit_id: unit_id,
      diagnosis: diagnosis,
      tindak_lanjut_id: tindak_lanjut_id,
      klinik_tujuan_id: klinik_tujuan_id
    });
  }
}
export default new InterfaceSkDiagnosa();
